module.exports = __webpack_public_path__ + "static/media/AAA2015.1e7a7a7f.jpg";